import type { IntervalType } from 'redux-store/slices/products/types';

export const planPaymentDescription: Record<IntervalType, string> = {
  week: '', //todo week description
  month:
    'A monthly subscription renews every month unless you cancel You may cancel it at any time in the settings and all the benefits will stay with you until your subscription expires',
  '3month':
    'A 3 month subscription renews every 3 months unless you cancel You may cancel it at any time in the settings and all the benefits will stay with you until your subscription expires',
  '6month':
    'A 6 month subscription renews every 6 months unless you cancel You may cancel it at any time in the settings and all the benefits will stay with you until your subscription expires',
  year: 'An annual subscription renews once a year unless you cancel You may cancel it at any time in the settings and all the benefits will stay with you until your subscription expires',
  '2-year':
    'A two-year subscription renews once every two years unless you cancel. You may cancel it at any time in the settings, and all the benefits will stay with you until your subscription expires.',
  lifetime:
    'A lifetime subscription is a one-time donation that gives you full access to all the features now and forever This subscription is your contribution to science It cant be cancelled renewed refunded or transferred',
  'year-gift': '',
  'quarterly': '',
  'semi-annual': '',
};
